const BASE_MODEL_URL =
    "https://storage.googleapis.com/magentadata/js/checkpoints/ddsp/";

const MODEL_URLS = [
    BASE_MODEL_URL + "flute",
    BASE_MODEL_URL + "tenor_saxophone",
    BASE_MODEL_URL + "trumpet",
    BASE_MODEL_URL + "violin",
];

class DdspNoWorker {
    constructor() {
        this.ddsps = null;
    }

    loadTfJs(callback) {
        const script = document.createElement('script');
        script.onload = () => {
            callback();
        };
        script.src = './tf.min.js';
        document.head.appendChild(script);
    }

    load() {
        this.loadTfJs(() => {
            const script = document.createElement('script');
            script.onload = () => {
                this.init();
            };
            script.src = './magenta-music@1.21.0-es6-ddsp.js';
            document.head.appendChild(script);
        })
    }

    sendEvent(eventName) {
        const event = document.createEvent("Event");
        event.initEvent(eventName, true, true);
        document.dispatchEvent(event);
    }

    init() {
        this.ddsps = MODEL_URLS.map((url) => new ddsp.DDSP(url));
        Promise.all(this.ddsps.map((ddsp) => ddsp.initialize())).then(() => {
            this.sendEvent("loadingModelEnd");
        });
    }

    warmUpModel() {
        this.synthesizeAudioFeatures(this.ddsps[0], {
            f0_hz: [0],
            loudness_db: [0],
        }).then(() => {
            this.sendEvent("warmupEnded");
        });
    }

    synthesize(stroke, audioFeatures, callback) {
        this.synthesizeAudioFeatures(this.ddsps[stroke.instrument], audioFeatures).then((samples) => {
            callback({
                samples: samples,
                stroke: stroke
            });
        });
    }

    async synthesizeAudioFeatures(ddsp, features) {
        if (!ddsp.model) return;
        const f0hzTensor = tf.tensor1d(features["f0_hz"], "float32");
        const loudnessTensor = tf.tensor1d(features["loudness_db"], "float32");
        const result = await ddsp.model.predict({
            f0_hz: f0hzTensor,
            loudness_db: loudnessTensor,
        });
        return await result.data();
    }
}
export { DdspNoWorker };